<template>
  <v-card class="rsu">
    <div style="float: right">
      <v-btn @click="$emit('closemodal')" icon><v-icon>close</v-icon></v-btn>
    </div>
    <v-card-text class="px-0"
      ><div v-if="editType == 'add'" class="headline primary--text mb-6">
        <Typography h2 bold :label="$t('Create project type')" style="padding-left: 54px" />
      </div>
      <div v-if="editType == 'edit'" class="headline primary--text mb-6">
        <Typography h2 bold :label="$t('Edit project type')" style="padding-left: 54px" />
      </div>
    </v-card-text>
    <v-card-actions>
      <div
        style="width: 100%"
        class="form-control px-3"
        :class="{ 'has-error': errors.has('รหัสประเภทโครงการ') }"
      >
        <label
          ><Typography h5 semiBold color="color-darkGrey" :label="`รหัสประเภทโครงการ*`"
        /></label>
        <input
          v-validate="'required'"
          name="รหัสประเภทโครงการ"
          style="padding-left: 12px !important"
          v-model="projecttypeno"
          placeholder="Mock-10-3"
          type="search"
          class="depainput rsu mb-0"
        />
        <span class="text-error" v-if="errors.has('รหัสประเภทโครงการ')">{{
          errors.first('รหัสประเภทโครงการ')
        }}</span>
      </div>
    </v-card-actions>
    <v-card-actions>
      <div
        style="width: 100%; padding-bottom: 0px"
        class="form-control px-3"
        :class="{ 'has-error': errors.has('ชื่อประเภทโครงการ') }"
      >
        <label
          ><Typography h5 semiBold color="color-darkGrey" :label="`ชื่อประเภทโครงการ*`"
        /></label>
        <input
          v-validate="'required'"
          name="ชื่อประเภทโครงการ"
          style="padding-left: 12px !important"
          v-model="name"
          placeholder="โครงการ Depa"
          type="search"
          class="depainput rsu mb-0"
        />
        <span class="text-error" v-if="errors.has('ชื่อประเภทโครงการ')">{{
          errors.first('ชื่อประเภทโครงการ')
        }}</span>
      </div>
    </v-card-actions>
    <v-card-actions style="flex-direction: column; justify-content: center">
      <div v-for="(item, k) in processData" :key="k" style="width: 95%">
        <project-type-item
          @ondelete="processData.splice(k, 1)"
          :dataindex="k"
          v-model="processData[k]"
        ></project-type-item>
      </div>
    </v-card-actions>
    <!-- <div class="text-xs-left">
      <v-btn
        @click="addProcess"
        small
        depressed
        color="#BECCDB"
        round
        class="px-3"
        style="text-transform: capitalize; color: #0c2f53; margin-left: 24px; height: 36px"
      >
        <i class="fas fa-plus mr-2"></i
        ><Typography h5 semiBold color="color-darkBlue" :label="`เพิ่มกระบวนการ`"
      /></v-btn>
    </div> -->
    <v-card-actions style="justify-content: center; padding: 40px 0px">
      <div class="text-xs-center rsu">
        <v-btn
          class="rsu"
          @click="$emit('closemodal')"
          round
          small
          outline
          color="primary"
          style="height: 30px"
          ><Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" style="width: 100px"
        /></v-btn>
        <v-btn
          :loading="saveloading"
          class="rsu"
          @click="onSave"
          round
          small
          depressed
          style="color: yellow; height: 30px"
          color="primary"
          ><Typography
            h5
            semiBold
            color="color-lightYellow"
            :label="$t('Save')"
            style="width: 100px"
        /></v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import UploadFileButton from '@/components/elements/UploadFileButton.vue'
import CustomFormManager from './CustomFormManager.vue'
import ProjectTypeItem from './ProjectTypeItem.vue'
import Typography from '@/components/elements/Typography.vue'
import api from '@/api'
import uniqid from 'uniqid'

export default {
  props: ['inputdata', 'editType'],
  components: {
    Multiselect,
    UploadFileButton,
    CustomFormManager,
    ProjectTypeItem,
    Typography
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  data() {
    return {
      processData: [
        {
          name: 'กระบวนการ',
          steps: [
            {
              name: 'ขั้นสมัคร',
              customform: '',
              id: uniqid() /* , dpType: 'Non-DP', tags: null  */
            },
            {
              name: 'ขั้นอนุมัติ',
              customform: '',
              id: uniqid() /* , dpType: 'Non-DP', tags: null  */
            }
          ]
        }
      ],
      showCustomerForm: false,
      name: '',
      saveloading: false,
      error_in_form_save_progress: '',
      projecttypeno: ''
    }
  },
  mounted() {
    if (this.editType == 'edit') {
      this.name = this.inputdata.typename
      this.projecttypeno = this.inputdata.projecttypeno
      var processData = this.inputdata.typedata.map(el => {
        return {
          name: el.name,
          steps: el.steps
        }
      })

      this.processData = processData
    }
  },
  methods: {
    save_progrees() {
      return new Promise(resolve => {
        var validationArray = this.$children.map(function(child) {
          return child.$validator.validateAll()
        })

        window.Promise.all(validationArray)
          .then(v => {
            v.some(element => {
              if (element == false) {
                throw 'exists error in child component'
              }
            })
            this.error_in_form_save_progress = false

            resolve(true)
          })
          .catch(() => {
            this.show_message_error_validation()
            resolve(false)
          })
      })
    },
    show_message_error_validation() {
      this.error_in_form_save_progress = true
    },

    addProcess() {
      this.processData.push({
        name: '',
        steps: [{ name: '', customform: {}, id: uniqid() }]
      })
    },
    async onSave() {
      var isValid = await this.$validator.validate()
      var isValid2 = await this.save_progrees()
      if (isValid && isValid2) {
        this.saveloading = true
        var result = this.processData.map(el => {
          return {
            name: el.name,
            steps: el.steps
          }
        })
        var steps = []
        result.forEach(val => {
          steps = [...steps, ...val.steps]
        })
        if (steps.length <= 1) {
          this.saveloading = false
          return this.$swal.fire({
            text: 'กรุณาใส่ข้อมูล step มากกว่า 1 step'
          })
        }
        var data = {
          typename: this.name,
          projecttypeno: this.projecttypeno,
          typedata: JSON.stringify(result)
        }

        var url = ''
        if (this.editType == 'edit') {
          Object.assign(data, { typeid: this.inputdata.id })
          url = 'updatedepaprojecttype'
        } else {
          url = 'createdepaprojecttype'
        }

        api[url](data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
            if (this.editType == 'add') {
              this.$emit('onCreate', { ...response.data[0], typedata: JSON.parse(data.typedata) })
            } else {
              this.$emit('onUpdate', {
                projecttypeno: data.projecttypeno,
                typename: data.typename,
                typedata: JSON.parse(data.typedata),
                id: data.typeid
              })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.greytext {
  color: rgb(173, 173, 173);
}

.uploaddepa {
  padding-right: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectTypeEdit.vue